import {fromJS} from 'immutable'
import firedux from '../firedux'
import {dispatch} from '../store'

import {
  PRESENCE_ENDPOINT,
  USERS_ENDPOINT,
  GUESTS_ENDPOINT,
  PRESENCE,
  ROLES
} from '../../config/constants'

const {AWAY} = PRESENCE
const {EXPERT, AUTHOR} = ROLES

import getUser from '../getters/user'

import setChatListUser from '../actions/set_chat_list_user'
import removeChatListUser from '../actions/remove_chat_list_user'
import changeChatListUserRole from '../actions/change_chat_list_user_role'
import setChatListGuests from '../actions/set_chat_list_guests'
import setUser from '../actions/set_user'

const onChatListPresence = (snapshot) => {
  if (!snapshot.exists()) return Promise.resolve()

  const uid      = snapshot.key()
  const presence = snapshot.val()

  return getUser(uid)
    .then((u) => dispatch(setChatListUser(u, presence)))
}

const onChatListPresenceRemoved = (snapshot) => {
  if (!snapshot.exists()) return Promise.resolve()

  const uid = snapshot.key()

  return getUser(uid)
    .then((u) => dispatch(removeChatListUser(u)))
}

const onChatListRoleChange = (snapshot) => {
  if (!snapshot.exists()) return Promise.resolve()

  const user = snapshot.val()
  const role = user.role
  const prevRole = role === EXPERT ? AUTHOR : EXPERT

  dispatch(setUser(user))
  dispatch(changeChatListUserRole(fromJS(user), role, prevRole))

  return Promise.resolve()
}

const onGuestsLoaded = (snapshot) => {
  if (!snapshot.exists()) return Promise.resolve()

  const guests = fromJS(snapshot.val())

  return Promise.resolve(dispatch(setChatListGuests(guests)))
}

export const watchChatListView = () => {
  const presenceRef = firedux.ref.child(PRESENCE_ENDPOINT).orderByValue().startAt(AWAY)
  const userRef = firedux.ref.child(USERS_ENDPOINT).orderByChild('role').startAt(EXPERT).endAt(AUTHOR)
  const guestRef = firedux.ref.child(GUESTS_ENDPOINT).orderByKey().limitToLast(40)

  presenceRef.on('child_added', onChatListPresence)
  presenceRef.on('child_changed', onChatListPresence)
  presenceRef.on('child_removed', onChatListPresenceRemoved)
  userRef.on('child_changed', onChatListRoleChange)
  guestRef.once('value', onGuestsLoaded)
}

export const unwatchChatListView = () => {
  const presenceRef = firedux.ref.child(PRESENCE_ENDPOINT).orderByValue().startAt(AWAY)
  const userRef = firedux.ref.child(USERS_ENDPOINT).orderByChild('role').startAt(EXPERT).endAt(AUTHOR)

  presenceRef.off('child_added', onChatListPresence)
  presenceRef.off('child_changed', onChatListPresence)
  presenceRef.off('child_removed', onChatListPresenceRemoved)
  userRef.off('child_changed', onChatListRoleChange)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/watchers/chat_list.js
 **/